// extracted by mini-css-extract-plugin
export default {"protocol":"Url_protocol__dGsU0"};